import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
export default (_ref => {
  let {
    className,
    override
  } = _ref;
  return /*#__PURE__*/React.memo(_ref2 => {
    let {
      children,
      ...props
    } = _ref2;
    return components.Group && /*#__PURE__*/React.createElement(components.Group, _extends({}, props, {
      className: className
    }, override.group), children);
  });
});